import React from 'react';
import { humanizeBadgeText } from './StatusBadge';

type TypeBadgeTone = 'neutral' | 'blue' | 'green' | 'amber' | 'red' | 'purple';

interface TypeBadgeProps {
  type: string;
  label?: string;
  tone?: TypeBadgeTone;
  className?: string;
}

const joinClasses = (...classes: Array<string | undefined | false>) =>
  classes.filter(Boolean).join(' ');

const TypeBadge: React.FC<TypeBadgeProps> = ({
  type,
  label,
  tone = 'neutral',
  className,
}) => (
  <span className={joinClasses('type-badge', `type-badge--${tone}`, className)}>
    {label || humanizeBadgeText(type)}
  </span>
);

export default TypeBadge;
